class InitPweController {
    constructor($scope, logger, httpRequest, $state, authService, formvalidateApi, $rootScope) {
        $rootScope.leftNavDisabled = true
        $('body').addClass('leftnav-close')
        // 初始化密码参数
        $scope.keyauditForm = {
            oldPassword: '',
            newPassword: '',
            newPassword1: '',
        }
        // 用户类型$scope.isFistLogin
        const userInfo = authService.getUserInfo()
        $scope.userType = userInfo.user.userType
        $scope.isFistLogin = userInfo.user.isFistLogin
        // 点击提交按钮交互
        $scope.submit = function submit() {
            const ret = formvalidateApi.run()
            if (ret) {
                if ($scope.keyauditForm.newPassword !== $scope.keyauditForm.newPassword1) {
                    logger.logError('两次密码输入不一致')
                    return
                }
                httpRequest.post_updatePassword($scope.keyauditForm, '修改密码成功').then(() => {
                    $('body').removeClass('leftnav-close')
                    $rootScope.leftNavDisabled = false
                    // !!修改为改完密码统一退出系统 重新登陆
                    // authService.logout();
                    // 判断是否处于初始化设置步骤，是则走初始化流程，不是则返回上一页
                    if ($scope.isFistLogin === 1) {
                        if ($scope.userType === 0 && localStorage.initialStatus == 0 && localStorage.deployType == 2) {
                            $state.go('license')
                        } else {
                            $state.go('login')
                        }
                    } else {
                        window.history.back()
                    }
                })
            }
        }
        $scope.cancel = function cancel() {
            $('body').removeClass('leftnav-close')
            $rootScope.leftNavDisabled = false
            // 系统管理员
            if ($scope.isFistLogin === 1) {
                $state.go('login')
            } else {
                window.history.back()
            }
        }
    }
}
InitPweController.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'authService', 'formvalidateApi', '$rootScope']
export default InitPweController


// WEBPACK FOOTER //
// ./src/app/main/sysinitial/InitPwCtrl.js